import moment from 'moment';
import React from 'react';
import { Link } from 'pages/CaseDetails/styledComponents';
import { mapOrderStatus, mapReturnStatus } from 'pages/CaseDetails/utils/order';
import { getItemPriceDisplay } from 'utils/helpers';

export const isDifferentPartNumber = (pair) =>
  pair.return?.partNumber &&
  pair.order?.partNumber &&
  pair.return?.partNumber !== pair.order?.partNumber;

export const isOrderLineCancelled = (pair) => mapOrderStatus(pair.order?.lineStatus) === 'Canceled';

export const getFormattedDate = (pair, date) => {
  if (!pair.order || isOrderLineCancelled(pair)) {
    return 'N/A';
  }

  return date ? moment(date).format('L') : 'TBD';
};

export const getOrderSerialNumber = (pair) => {
  if (!pair.order || isOrderLineCancelled(pair)) {
    return 'N/A';
  }

  return pair.order?.serialNumbers[0] ? <Link>{pair.order.serialNumbers[0]}</Link> : 'TBD';
};

export const getReturnRows = (pair, formatPrice, itemCurrencyCode) => {
  const serialNumber = pair.return?.serialNumbers[0];

  const returnSerialNumber = serialNumber || 'N/A';
  const returnStatus = pair.return ? mapReturnStatus(pair.return?.lineStatus) : 'N/A';
  const pairTotalPrice = pair.order
    ? getItemPriceDisplay(pair.order, formatPrice, itemCurrencyCode) ||
      formatPrice(0, itemCurrencyCode)
    : '';

  const returnSerialNumberRow = (
    <>RMA Serial #: {serialNumber ? <Link>{returnSerialNumber}</Link> : returnSerialNumber}</>
  );
  const returnStatusRow = <>Return Status: {returnStatus}</>;
  const pairPriceRow = <>{pairTotalPrice}</>;

  return [returnSerialNumberRow, returnStatusRow, pairPriceRow];
};

export const getShippingStatus = (pair) => {
  if (!pair.order) {
    return 'N/A';
  }

  return mapOrderStatus(pair.order.lineStatus);
};

export const getShippingMethod = (pair) => {
  if (!pair.order || isOrderLineCancelled(pair)) {
    return 'N/A';
  }

  return pair.order?.shippingMethod || 'TBD';
};

export const getTrackingNumber = (pair) => {
  if (!pair.order || isOrderLineCancelled(pair)) {
    return 'N/A';
  }

  if (!pair.order?.trackingNumberURL || !pair.order?.trackingNumber) {
    return 'TBD';
  }

  return (
    <a target="_blank" rel="noopener noreferrer" href={pair.order.trackingNumberURL}>
      {pair.order.trackingNumber}
    </a>
  );
};
